<template>
  <div class="login-page items-center justify-center">
    <!-- <div class="mx-auto"> -->
    <div class="login-container">
      <v-card v-if="window == 0" class="item-card pt-12 pb-12" elevation="0">
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <div class="logo">
          <!-- <v-img v-if="!hasLogo()" src="@/assets/logomark.png"></v-img> -->
          <v-img v-if="!hasLogo() && logo" :src="logo"></v-img>
          <v-img v-if="hasLogo()" src="@/assets/culionline.png"></v-img>
        </div>
        <div class="titile mt-2 mb-10">
          <v-card-title
            primary-title
            class="justify-center pa-0 mb-3 tula-title"
            >Register</v-card-title
          >
          <p
            class="subtitle text-center origanization-detail font-weight-regular grey--text text--darken-1"
          >
            Create your Organization Account
          </p>
        </div>

        <v-form
          ref="form"
          v-model="valid"
          v-on:submit.prevent="submit"
          class="px-5"
          v-if="loginEmail"
        >
          <v-text-field
            outlined
            v-model="model.firstName"
            name="firstName"
            label="First Name"
            :rules="firstNameRule"
            required
            clearable
            dense
            :autofocus="false"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template> -->
          </v-text-field>
          <v-text-field
            outlined
            label="Last Name"
            v-model="model.lastName"
            name="lastName"
            :rules="lastNameRule"
            required
            clearable
            dense
            :autofocus="false"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template> -->
          </v-text-field>
          <v-select
            label="Gender"
            dense
            outlined
            v-model="model.gender"
            :items="genders"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-gender-male-female</v-icon>
            </template> -->
          </v-select>
          <v-text-field
            outlined
            label="E-mail"
            v-model="model.email"
            type="email"
            name="email"
            :rules="[requireRule, emailRule]"
            required
            clearable
            dense
            :autofocus="false"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template> -->
          </v-text-field>
          <v-textarea
            outlined
            label="Description"
            v-model="model.description"
            name="description"
            clearable
            dense
            :autofocus="false"
            
            auto-grow
            :rows="1"

            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template> -->
          </v-textarea>
          <v-text-field
            outlined
            v-model="model.username"
            label="Username"
            name="username"
            :rules="usernameRule"
            required
            clearable
            dense
            :autofocus="false"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template> -->
          </v-text-field>
          <v-text-field
            outlined
            v-model="model.password"
            type="password"
            label="Password"
            :rules="[passwordRule, passwordMinRule]"
            clearable
            dense
            :autofocus="false"
            name="password"
            class="md-w-100 xs-full-width m-auto user-icon"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">far fa-key</v-icon>
            </template> -->
          </v-text-field>
          <v-text-field
            outlined
            label="Confirm Password"
            v-model="model.confirmPassword"
            type="password"
            :rules="
              model.password.length > 0
                ? [confirmPasswordRule, conFirmPasswordMatchedRules]
                : []
            "
            clearable
            dense
            :autofocus="false"
            name="confirmPassword"
            class="md-w-100 xs-full-width m-auto user-icon"
          >
            <!-- <template v-slot:prepend-inner>
              <v-icon class="mr-2">far fa-key</v-icon>
            </template> -->
          </v-text-field>

          <div class="text-center mt-2 mb-8">
            <v-btn
              :color="$buttonColor"
              class="md-w-100 xs-full-width white--text next-btn"
              large
              elevation="0"
              @click="submit"
              :disabled="!valid"
              >Register</v-btn
            >
          </div>

          <p class="mt-5 register-container size font-weight-light">
            Have an account?
            <a @click="gotoSignin">
              <span class="subtitle-1 font-weight-bold">Sign in</span>
            </a>
          </p>
          <div class="text-center py-12">
            <a
              href="https://nerdof.com/termOfUse"
              class="text--primary grey--text text--darken-1 txt-hyperLink"
              >Terms & Condition</a
            >
          </div>
        </v-form>
      </v-card>
      <v-card
        class="item-card pt-12 pb-12 hidden-xs login-information"
        elevation="0"
      >
        <div class="information">
          <p class="display-1 title">Advance E-Learning Platform</p>
          <p class="title detail white--text">
            Enhancing teaching and learning experience with breakthrough
            features.
          </p>
        </div>
      </v-card>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import colors from "vuetify/lib/util/colors";
import warnningComponent from "@/components/warningAlert.vue";
import Vue from 'vue';

export default {
  components: {
    warnningComponent,
  },
  data: () => ({
    window: 0,
    valid: true,
    valid2: true,
    snackbar: false,
    errText: "",
    model: {
      email: "",
      username: "",
      password: "",
      firstName: "",
      lastName: "",
      gender: null,
      confirmPassword: "",
      description: ""
    },
    loading: false,
    companyData: null,
    textWarning: "",
    typeWarning: "",
    showWarnnig: false,
    subDomain: null,
    logo: null,
    companyID: null,
    genders: [
      {
        text: "--- Not set ---",
        value: null,
      },
      {
        text: "Male",
        value: "male",
      },
      {
        text: "Female",
        value: "female",
      },
    ],
    canRegister: false,
    loginFacebook: false,
    loginGoogle: false,
    loginAppleID: false,
    loginEmail: false,
    externalAccessGroup: null,
  }),
  computed: {
    requireRule() {
      return (v) => !!v || "Email is required";
    },
    emailRule() {
      return (v) => /.+@.+\..+/.test(v) || "E-mail must be valid";
    },
    firstNameRule() {
      return [(v) => !!v || "First name is required"];
    },
    lastNameRule() {
      return [(v) => !!v || "Last name is required"];
    },
    genderRule() {
      return [(v) => !!v || "Last name is required"];
    },
    usernameRule() {
      return [(v) => !!v || "Username is required"];
    },
    passwordRule() {
      return (v) => !!v || "Password is required";
    },
    passwordMinRule() {
      return (v) => v.length >= 8 || "Passwords must be at least 8 characters.";
    },
    confirmPasswordRule() {
      return (v) => !!v || "Confirm password is required";
    },
    conFirmPasswordMatchedRules() {
      let rule = true;
      if (this.model.password.length > 0) {
        rule = (v) =>
          (!!v && v === this.model.password) ||
          "Please enter the matched password";
      }
      return rule;
    },
  },
  // watch: {
  //   window(val) {
  //     if (val == 0) {
  //       this.$vuetify.theme.themes.light.primary = colors.blue.darken2;
  //     }
  //   }
  // },
  mounted() {
    // async beforeMount() {
    // const user = this.$cookies.get("user_token");
    // if (user != null) {
    //   this.$router.replace({ path: "/" });
    // }
    const host = window.location.host;
    const parts = host.split(".");
    let subDomain = "";
    if (host.indexOf("localhost") > -1 && parts.length > 1) {
      if (parts[0] !== "localhost") {
        subDomain = parts[0];
      }
    } else if(host.indexOf("culionline") > -1){
      subDomain = "culionline"  //support culionline.com = culionline.nerdof.com
    } else if (parts.length >= 2) {
      subDomain = parts[0];
    }

    if (subDomain.length > 0) {
      this.subDomain = subDomain;
      this.$http
        .get(
          `${this.$store.state.api}/company/detail/subdomain?domainname=${this.subDomain}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.logo = resp.data.result.company.logo;
            this.companyData = resp.data.result.company || null;
            // this.$vuetify.theme.themes.light.primary = this.companyData.themeColor;
            // localStorage.setItem("theme", this.companyData.themeColor);
            Vue.prototype.$buttonColor = this.companyData.buttonColor;
            this.logo = resp.data.result.company.logo;
            this.loginFacebook = resp.data.result.company.loginFacebook;
            this.loginGoogle = resp.data.result.company.loginGoogle;
            this.loginAppleID = resp.data.result.company.loginAppleID;
            this.loginEmail = resp.data.result.company.loginEmail;
            //
            // this.$http
            //   .get(
            //     `${this.$store.state.api}/usergroup/externalAccess/list?companyID=${this.companyData._id}`
            //   )
            //   .then((usergroupResp) => {
            //     if (
            //       usergroupResp.status == 200 &&
            //       usergroupResp.data.status == true
            //     ) {
            //       this.externalAccessGroup = usergroupResp.data.result;
            //     } else {
            //       // window.location.href = "https://nerdof.com";
            //       // this.gotoLoginByDomain()
            //     }
            //   })
            //   .catch((err) => {
            //     // window.location.href = "https://nerdof.com";
            //     // this.gotoLoginByDomain()
            //   });
            //
          } else {
            // window.location.href = "https://nerdof.com";
            this.gotoLoginByDomain();
          }
        })
        .catch((err) => {
          // window.location.href = "https://nerdof.com";
          this.gotoLoginByDomain();
        });
      // }
    }
  },
  methods: {
    gotoSignin() {
      this.$router.replace({
        name: "login",
      });
    },
    gotoLoginByDomain() {
      const host = window.location.host;
      const parts = host.split(".");
      if (window.location.host.indexOf("localhost") > -1) {
        window.location.href =
          window.location.protocol +
          "//localhost" +
          ":" +
          window.location.port +
          "/login";
      } else {
        window.location.href =
          window.location.protocol +
          "//"+ "app." +
          parts[1] +
          "." +
          parts[2] +
          "/login";
      }
    },
    warnnig(text, type) {
      this.textWarning = text;
      this.typeWarning = type;
      this.showWarnnig = true;
    },
    submit() {
      if (this.$refs.form.validate()) {
        // this.identifyCompany();
        this.register();
      } else {
        // this.erroHandler("กรุณากรอกข้อมูลอีเมล หรือ ชื่อผู้ใช้");
      }
    },
    register() {
      this.loading = true;
      const url = `${this.$store.state.api}/account/tula/register`;
      this.$http
        .post(url, {
          email: this.model.email,
          username: this.model.username,
          password: this.model.password,
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          gender: this.model.gender,
          companies: [this.companyData._id],
          user_groups: [],
          description: this.model.description
        })
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            // if (resp.data.status == true) {
            this.signin(resp.data.result._id);
          } else {
            this.warnnig(resp.data.message, "warning");
            // this.erroHandler(resp.data.message);
          }
        })
        .catch((err) => {
          if (err.response.status == 403) {
            this.warnnig(err.response.data.message, "warning");
          } else {
            this.warnnig(
              "Something went wrong, service error or internet connection has proplem",
              "warning"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    erroHandler(msg) {
      this.errText = msg;
      this.snackbar = true;
    },
    signin(userID) {
      this.loading = true;
      let url = `${this.$store.state.api}/account/tula/login`;
      const params = {
        id: userID,
        password: this.model.password,
        platform: "Web app",
        device: this.$platformDetect.ua,
        osversion: `${this.$platformDetect.os}`,
        browser: `${this.$browserDetect.meta.name} ${this.$browserDetect.meta.version}`,
      };
      this.$http
        .post(url, params)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.$cookies.set(
              "user_token",
              resp.data.result.token,
              resp.data.result.endTime
            );
            this.userInfo(resp.data.result.endTime);
          }
          // else {
          //   this.loading = false;
          //   // error handler
          //   // this.erroHandler("รหัสผ่านไม่ถูกต้องกรุณาลองใหม่อีกครั้ง");
          //   this.warnnig(resp.data.message, "warning");
          // }
        })
        .catch((err) => {
          // error handler
          this.loading = false;
          if (err.response.status == 403) {
            this.warnnig(err.response.data.message, "warning");
          } else {
            this.warnnig(
              "Something went wrong, service error or internet connection has proplem",
              "warning"
            );
          }
        });
    },
    userInfo(exp) {
      this.$http
        .get(`${this.$store.state.api}/account/tula/info`)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            const info = {
              companies: resp.data.result.info.companies,
              displayName: resp.data.result.info.displayName,
              email: resp.data.result.info.email,
              firstName: resp.data.result.info.firstName,
              image: resp.data.result.info.image,
              isTeacher: resp.data.result.info.isTeacher,
              lastName: resp.data.result.info.lastName,
              _id: resp.data.result.info._id,
              setting: resp.data.result.setting,
            };
            this.$cookies.set("user_info", info, exp);
            Vue.prototype.$userInfo = info;
            if (info.companies[0].connectToolsWith) {
              setGoogleAnalytic(
                info.companies[0].connectToolsWith.googleAnalytics
              );
            }
            this.setNav()
            let fromUrl = localStorage.getItem("fromUrl")
              ? JSON.parse(localStorage.getItem("fromUrl"))
              : null;
            localStorage.removeItem("fromUrl");
            fromUrl
              ? this.$router.replace({
                  path: fromUrl.path,
                  query: fromUrl.query,
                })
              : this.$router.replace({
                  name: "home",
                });
          }
        })
        .catch((err) => {});
      // .finally(() => {
      //   this.loading = false;
      // });
    },
    setNav() {
      let horizontal = [
        "banner_slider",
        "my_course_vertical_gridview",
        "course_vertical_gridview",
        "category_horizontal_listview",
      ];
      let vertical = [
        "teacher_horizontal_listview",
        "category_horizontal_listview",
        "tag_list",
        "grade_horizontal_listview",
      ];
      const user = Vue.$cookies.get("user_token");
      let company = Vue.prototype.$userInfo.companies[0]._id;
      let settings = Vue.prototype.$userInfo.setting;
      let item = settings.filter((item) => item.name == "Home");
      Vue.prototype.$elements = [];
      this.$http
        .get(
          `${this.$store.state.api}/home/V2?index=${item[0].priority}${
            user ? "" : "&companyID=" + company
          }`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            Vue.prototype.$elements = resp.data.result.elements;
            EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);

            Vue.prototype.$itemHorizontal = resp.data.result.elements.filter(
              (item) => horizontal.includes(item.template)
            );
            dataVertical = resp.data.result.elements.filter((item) =>
              vertical.includes(item.template)
            );
            dataVertical.forEach((element) => {
              Vue.prototype.$itemVertical[element.template] = element;
            });
            this.$emit("data", Vue.prototype.$itemVertical);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    mapCompanyBySubDomain(companies) {
      if (!this.subDomain) {
        return 0;
      }
      const companyNames = companies.map((t) => {
        return t.companies.map((c) => c.keyIcon);
      });
      let result = -1;
      for (let i = 0; i < companyNames.length; i += 1) {
        const indexOfCompany = companyNames[i].indexOf(this.subDomain);
        if (indexOfCompany > -1) {
          result = i;
          this.logo = companies[i].companies[indexOfCompany].logo;
          break;
        }
      }
      return result > -1 ? result : 0;
    },
    hasLogo() {
      return this.subDomain === "culionline";
    },
  },
};
function setGoogleAnalytic(id) {
  if (id) {
    window.ga =
      window.ga ||
      function () {
        (ga.q = ga.q || []).push(arguments);
      };
    ga.l = +new Date();
    // Trace debugging
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging
    // window.ga_debug = {trace: true}
    ga("create", id, "auto");
    // if (isLocalhost) {
    //   ga('set', 'sendHitTask', null)
    // }
  }
}
</script>

<style scoped lang="scss">
.txt-hyperLink {
  text-decoration: underline;
}
.logo {
  width: 45%;
  // width: 160px;
  margin: 0 auto;
}
.login-page {
  background: rgb(1, 143, 179);
  background: linear-gradient(
    90deg,
    rgba(1, 143, 179, 1) 0%,
    rgba(6, 48, 115, 1) 88%
  );
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
  position: relative;
}

.md-w-100 {
  width: 90%;
}
.or-line {
  width: 74%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 10px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 30px;
  color: #e0e0e0;
}
.w-auto {
  width: auto !important;
}
.m-auto {
  margin: 0 auto !important;
}
.md-position-bottom-0 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.md-position-relative {
  position: relative !important;
}

@media only screen and (max-width: 768px) {
  .or-line {
    width: 94%;
  }
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  // .item-card {
  //   width: 45%;
  //   min-height: 560px;
  // }
  .item-card {
    // width: 45%;
    width: 100%; //ipad
    min-height: 560px;
  }
  .hidden-xs {
    display: none;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
  .md-hidden {
    display: none;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 35%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 30%;
  }
}
.login-container {
  width: 80%;
  display: flex;
  flex-flow: row wrap;
  @media only screen and (max-width: 767px) {
    display: block;
    align-self: center;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-xs {
    display: none;
  }
  .xs-no-margin {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .xs-no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .event-cover-box {
    margin-top: -14px;
  }
  .responsive_btn {
    width: 77%;
  }
}
.login-information {
  // height: 686.609px;
  // background-color: rgb(39,117,161);
  // background-color: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%);
  // background-image:url('../assets/login-information.jpg');

  // background: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%), url('../assets/login-information.jpg');
  // color: rgb(255, 255, 255);
  // min-height:100%;
  // background:linear-gradient(0deg, rgba(255, 0, 150, 0.3), rgba(255, 0, 150, 0.3)), url(http://lorempixel.com/800/600/nature/2);
  background: linear-gradient(
      90deg,
      rgba(19, 61, 160, 0.7) 0%,
      rgba(0, 174, 200, 0.7) 88%
    ),
    url("../assets/login-information.jpg");
  background-size: cover;
  // @media only screen and (max-width: 769px) {
  //   .login-information {
  //     width: 45% !important;
  //   }
  // }
  width: 65%;
  position: relative;
  .information {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translate(0, -50%);
  }
}
@media only screen and (min-width: 774px) and (max-width: 1028) {
  .login-information {
    width: 55%;
  }
}
.login-container {
  padding-top: 40px;
  padding-bottom: 40px;
  .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 0px;
  }
}
.display-1.title {
  line-height: 3.5rem;
  font-size: 45px !important;
  color: white;
  margin-bottom: 30px;
}
.title.detail {
  font-weight: 400;
  color: #dae5eb !important;
}
// .mt-3 {
//   margin-bottom: 30px;
// }
.origanization-detail {
  font-size: 16px;
}
.tula-title {
  font-weight: bold !important;
  font-size: 26px !important;
}
.next-btn {
  font-size: 18px;
  border-radius: 0%;
}
.account-color {
  color: #072f72;
  font-weight: bold;
}
.txt-field {
  border-radius: 0%;
}
</style>
<style lang="scss">
/* .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: unset;
} */
.user-icon {
  .v-icon.v-icon {
    font-size: 22px !important;
    color: #b5b5b5;
  }
}
.register-container {
  padding-left: 17px;
}
</style>